import React, { memo, useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import CheckSvg from 'images/v5/icons/check.svg';
import Button from 'layout/atoms/Button/Button';
import Caption from 'layout/atoms/Caption';
import Label from 'layout/atoms/Label';
import Loader from 'layout/atoms/Loader/Loader';
import Modal from 'layout/atoms/Modal/Modal';
import TableGrid, { Body, Cell, Footer, Head, Row } from 'layout/atoms/TableGrid/TableGrid';
import { closeModal } from 'store/layoutSlice';
import { selectSpecificationCostsStatus, selectSpecificationCostsVariantDetails, } from 'store/specificationCostsSlice';
import downloadFile from 'utils/downloadUtils';
function EstimatedCostsDetails() {
    var _a, _b, _c, _d;
    const { t, i18n } = useTranslation(['specification', 'common']);
    const dispatch = useDispatch();
    // const modelSpecificationId = useSelector((state) => state.specificationDetails.item.id);
    const estimatedCostDetailsData = useSelector(selectSpecificationCostsVariantDetails);
    const fetchStatus = useSelector(selectSpecificationCostsStatus).fetchCostDetails;
    const isLoading = fetchStatus === 'loading' || fetchStatus === 'idle';
    const [exporting, setExporting] = useState(false);
    const onClickExport = useCallback(() => {
        setExporting(true);
        downloadFile(`/export/getSpecificationVariantCosts/${estimatedCostDetailsData.id}/${i18n.language}`).finally(() => setExporting(false));
    }, [i18n.language, estimatedCostDetailsData.id]);
    return (React.createElement(Modal, { name: "estimatedCostsDetails", size: "l", header: React.createElement(Label, { weight: "strong" }, t('specification_cost_details_modal.single_variant.title', {
            colorName: (_a = estimatedCostDetailsData === null || estimatedCostDetailsData === void 0 ? void 0 : estimatedCostDetailsData.color) === null || _a === void 0 ? void 0 : _a.name,
            sizeName: (_c = (_b = estimatedCostDetailsData === null || estimatedCostDetailsData === void 0 ? void 0 : estimatedCostDetailsData.size) === null || _b === void 0 ? void 0 : _b.sizeName) === null || _c === void 0 ? void 0 : _c.name,
        })), footer: React.createElement(React.Fragment, null,
            React.createElement(Button, { theme: "ghost", onClick: () => dispatch(closeModal({ name: 'estimatedCostsDetails' })) }, t('common:close')),
            React.createElement(Button, { color: "primary", leftIcon: React.createElement(CheckSvg, null), onClick: onClickExport, loading: exporting, disabled: isLoading }, t('specification_cost_details_modal.average.export'))) }, isLoading ? (React.createElement(Loader, null)) : (React.createElement(TableGrid, { columns: [
            ['120px', '1fr'],
            ['100px', '1fr'],
            ['100px', '1fr'],
            ['80px', '1fr'],
            ['120px', '1fr'],
            ['120px', '1fr'],
            ['80px', '1fr'],
            ['120px', '1fr'],
        ] },
        React.createElement(Head, null,
            React.createElement(Row, { head: true },
                React.createElement(Cell, null, t('product')),
                React.createElement(Cell, null, t('variant')),
                React.createElement(Cell, null, t('component_consumptions')),
                React.createElement(Cell, null, t('common:unit')),
                React.createElement(Cell, null, t('specification_cost_details_modal.common.unit_price')),
                React.createElement(Cell, null, t('common:cost')),
                React.createElement(Cell, null, t('common:exchange_rate')),
                React.createElement(Cell, null, t('specification_cost_details_modal.common.weighted_average_unit_price', {
                    currency: 'PLN',
                })))),
        React.createElement(Body, null, (_d = estimatedCostDetailsData === null || estimatedCostDetailsData === void 0 ? void 0 : estimatedCostDetailsData.componentVariantCostSummaries) === null || _d === void 0 ? void 0 : _d.map((variant) => (React.createElement(Row, { key: variant.component.name },
            React.createElement(Cell, null, variant.component.name),
            React.createElement(Cell, null, variant.color),
            React.createElement(Cell, null, variant.consumptionValue),
            React.createElement(Cell, null, variant.consumptionType.labelPL),
            React.createElement(Cell, null,
                variant.price.value,
                " ",
                variant.price.currencyIsoCode),
            React.createElement(Cell, null,
                variant.costInComponentVariantCurrency.value,
                ' ',
                variant.costInComponentVariantCurrency.currencyIsoCode),
            React.createElement(Cell, null, Number(variant.exchangeRate.toFixed(2))),
            React.createElement(Cell, null,
                Number(variant.costInSpecificationCurrency.toFixed(2)),
                " PLN"))))),
        React.createElement(Footer, null,
            React.createElement(Row, { foot: true },
                React.createElement(Cell, null),
                React.createElement(Cell, { span: 6, align: "right" },
                    React.createElement(Caption, { color: "subtle" }, t('common:total'))),
                React.createElement(Cell, null,
                    React.createElement(Caption, { color: "subtle" }, estimatedCostDetailsData === null || estimatedCostDetailsData === void 0 ? void 0 : estimatedCostDetailsData.estimatedCost))))))));
}
export default memo(EstimatedCostsDetails);
